import {NgModule} from "@angular/core";
import {AuditsServiceProvider} from "./services/audits-service/audits-service";

@NgModule({
  providers: [
    AuditsServiceProvider
  ]
})
export class SellionsAuditsModule {}



// WEBPACK FOOTER //
// ./src/modules/audits/audits.module.ts